import React, { useState } from 'react';
import './RoundResultPhase.css';
import Button from '../ui/Button';
import Card from '../ui/Card';
import { useGame } from '../../contexts/GameContext';
import { continueToNextRound, showFinalResults } from '../../firebase/services';
import { getCardById } from '../../data/cards';

const RoundResultPhase = () => {
  const { lobby, isHost } = useGame();
  const [isAdvancing, setIsAdvancing] = useState(false);

  if (!lobby || !lobby.roundResult) {
    return <div className="round-result-loading">Sonuçlar yükleniyor...</div>;
  }

  const {
    roundNumber,
    eliminatedThisRound,
    isTie,
    thorKillId,
    artemisKillId,
    isGameOver,
    winningTeam,
    winMessage
  } = lobby.roundResult;

  const handleContinue = async () => {
    if (isAdvancing) return;
    setIsAdvancing(true);
    try {
      if (isGameOver) {
        await showFinalResults(lobby.code);
      } else {
        await continueToNextRound(lobby.code);
      }
    } catch (error) {
      console.error('Error advancing:', error);
      setIsAdvancing(false);
    }
  };

  const getWinnerClassName = () => {
    switch (winningTeam) {
      case 'werewolf': return 'round-result-winner--werewolf';
      case 'villager': return 'round-result-winner--villager';
      case 'tanner': return 'round-result-winner--tanner';
      default: return '';
    }
  };

  const getWinnerTitle = () => {
    switch (winningTeam) {
      case 'werewolf': return 'Kurt Takımı Kazandı!';
      case 'villager': return 'Köylü Takımı Kazandı!';
      case 'tanner': return 'Düzenbaz Kazandı!';
      default: return 'Oyun Bitti';
    }
  };

  // Separate vote-eliminated from ability-eliminated
  const voteEliminated = eliminatedThisRound.filter(
    p => p.id !== thorKillId && p.id !== artemisKillId
  );
  const thorVictim = thorKillId ? eliminatedThisRound.find(p => p.id === thorKillId) : null;
  const artemisVictim = artemisKillId ? eliminatedThisRound.find(p => p.id === artemisKillId) : null;

  // Alive player counts for status display
  const allEliminated = lobby.eliminatedPlayerIds || [];
  const aliveCount = lobby.players.filter(p => !allEliminated.includes(p.id)).length;

  return (
    <div className="round-result-phase">
      <div className="round-result-header">
        <span className="round-result-round-badge">Tur {roundNumber}</span>
        <h2 className="round-result-title">Oylama Sonucu</h2>
      </div>

      {isTie && eliminatedThisRound.length === 0 && (
        <div className="round-result-tie">
          <p>Oylamada eşitlik oldu, kimse köyden atılmadı!</p>
        </div>
      )}

      {voteEliminated.length > 0 && voteEliminated.map(eliminated => {
        const cardInfo = getCardById(eliminated.card);
        return (
          <div key={eliminated.id} className="round-result-eliminated">
            <h3>Köyden Atılan</h3>
            <div className="round-result-eliminated-info">
              <div className="round-result-eliminated-name">{eliminated.name}</div>
              {cardInfo && (
                <div className="round-result-eliminated-card">
                  <Card cardId={eliminated.card} revealed={true} />
                </div>
              )}
            </div>
          </div>
        );
      })}

      {thorVictim && !voteEliminated.find(p => p.id === thorVictim.id) && (
        <div className="round-result-eliminated round-result-eliminated--special">
          <h3>Thor'un Hedefi</h3>
          <div className="round-result-eliminated-info">
            <div className="round-result-eliminated-name">{thorVictim.name}</div>
            <div className="round-result-eliminated-detail">Thor'un oyu ile öldürüldü</div>
            <div className="round-result-eliminated-card">
              <Card cardId={thorVictim.card} revealed={true} />
            </div>
          </div>
        </div>
      )}

      {artemisVictim && (
        <div className="round-result-eliminated round-result-eliminated--special">
          <h3>Artemis'in İntikamı</h3>
          <div className="round-result-eliminated-info">
            <div className="round-result-eliminated-name">{artemisVictim.name}</div>
            <div className="round-result-eliminated-detail">Artemis öldürüldüğü için hedefi de öldü</div>
            <div className="round-result-eliminated-card">
              <Card cardId={artemisVictim.card} revealed={true} />
            </div>
          </div>
        </div>
      )}

      <div className="round-result-status">
        <span>Hayatta kalan: {aliveCount} oyuncu</span>
      </div>

      {isGameOver && (
        <div className={`round-result-winner ${getWinnerClassName()}`}>
          <h2 className="round-result-winner-title">{getWinnerTitle()}</h2>
          <p className="round-result-winner-description">{winMessage}</p>
        </div>
      )}

      {!isGameOver && (
        <div className="round-result-continue-info">
          <p>Oyun devam ediyor. Bir sonraki tartışma turuna geçilecek.</p>
        </div>
      )}

      {isHost && (
        <div className="round-result-actions">
          <Button
            onClick={handleContinue}
            variant="primary"
            fullWidth={true}
            disabled={isAdvancing}
          >
            {isAdvancing
              ? 'Geçiliyor...'
              : isGameOver
                ? 'Tüm Sonuçları Gör'
                : 'Sonraki Tura Geç'}
          </Button>
        </div>
      )}

      {!isHost && (
        <div className="round-result-waiting">
          <p>
            {isGameOver
              ? 'Kurucu sonuç ekranına geçtiğinde sonuçlar gösterilecek.'
              : 'Kurucu sonraki tura geçtiğinde tartışma başlayacak.'}
          </p>
        </div>
      )}
    </div>
  );
};

export default RoundResultPhase;
